import { transformObjectValuesToObject } from '../utils/transformObjectValuesToObject';
import { ValuesOf } from '../utils/types';

import { CountryCode, TCountryCodes } from './country-code';

const Genders = {
  Male: 'male',
  Female: 'female',
  Other: 'other',
} as const;

type TGender = ValuesOf<typeof Genders>;

const gendersEnum = transformObjectValuesToObject<TGender>(Genders);

// Russia collects only the two binary options
const getAvailableGenders = (countryCode?: TCountryCodes): TGender[] =>
  countryCode === CountryCode.Russia
    ? [Genders.Male, Genders.Female]
    : [Genders.Male, Genders.Female, Genders.Other];

export type { TGender };
export { gendersEnum, Genders, getAvailableGenders };
